/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef } from 'react';
import Table from '../../components/common/Table';
import axios from 'axios';
import styled from 'styled-components';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import swal from 'sweetalert2';
import Loading from '../../components/common/Loading';

const Container = styled.div`
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  height: 94vh;
  overflow: scroll;
  width: 100%;
  margin: 16px 16px 16px 0;
  padding: 24px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.04), 0 4px 20px rgba(0, 0, 0, 0.06);
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Toolbar = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
  flex-wrap: wrap;
  gap: 8px;
`;

const BtnGroup = styled.div`
  display: flex;
  gap: 8px;
  align-items: center;
`;

const Btn = styled.button`
  padding: 7px 14px;
  border: none;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  background: ${({ $variant }) =>
    $variant === 'excel' ? '#1d6f42' :
    $variant === 'primary' ? '#007aff' :
    $variant === 'danger' ? '#fef2f2' : '#f3f4f6'};
  color: ${({ $variant }) =>
    ($variant === 'excel' || $variant === 'primary') ? '#fff' :
    $variant === 'danger' ? '#dc2626' : '#374151'};
  &:hover { opacity: 0.85; }
`;

const HistoryPanel = styled.div`
  width: 100%;
  margin-bottom: 20px;
`;

const HistoryCard = styled.div`
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const HistoryInfo = styled.div`
  flex: 1;
`;

const HistoryDate = styled.div`
  font-size: 14px;
  font-weight: 600;
  color: #1d1d1f;
`;

const HistoryMemo = styled.div`
  font-size: 13px;
  color: #86868b;
  margin-top: 2px;
`;

const ChangeBadge = styled.span`
  padding: 2px 8px;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 600;
  background: #eef2ff;
  color: #4338ca;
  margin-right: 12px;
`;

const TotalProductListPage = () => {
  const [products, setProducts] = useState();
  const [rawData, setRawData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [history, setHistory] = useState([]);
  const fileRef = useRef(null);

  const getProducts = async () => {
    try {
      setIsLoading(true);
      let { data: res } = await axios.get('/admin/products/pricelist');
      setRawData(res);
      const formatted = res.map((r) => ({
        main_category: r.main_category,
        sub_category: r.sub_category,
        product_name: r.product_name,
        vip: r.vip ? r.vip.toLocaleString('ko-KR') : '0',
        mall: r.mall ? r.mall.toLocaleString('ko-KR') : '0',
        level1: r.level1 ? r.level1.toLocaleString('ko-KR') : '0',
        level2: r.level2 ? r.level2.toLocaleString('ko-KR') : '0',
        level3: r.level3 ? r.level3.toLocaleString('ko-KR') : '0',
        school: r.school ? r.school.toLocaleString('ko-KR') : '0',
      }));
      setIsLoading(false);
      setProducts(formatted);
    } catch (e) {
      console.log(e);
      setIsLoading(false);
    }
  };

  const handleExcelDownload = () => {
    if (!rawData.length) return;
    const rows = rawData.map((r) => ({
      '제조사': r.main_category,
      '카테고리': r.sub_category,
      '제품명': r.product_name,
      'VIP': r.vip || 0,
      'Mall': r.mall || 0,
      'Level1': r.level1 || 0,
      'Level2': r.level2 || 0,
      'Level3': r.level3 || 0,
      'School': r.school || 0,
    }));
    const ws = XLSX.utils.json_to_sheet(rows);
    ws['!cols'] = [
      { wch: 15 }, { wch: 25 }, { wch: 40 },
      { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 }, { wch: 10 },
    ];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, '가격표');
    const buf = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
    saveAs(new Blob([buf], { type: 'application/octet-stream' }), '전체제품가격표.xlsx');
  };

  const handleExcelUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    e.target.value = '';

    const { value: memo } = await swal.fire({
      title: '가격 일괄 변경',
      text: '변경 사유를 입력해주세요 (선택)',
      input: 'text',
      inputPlaceholder: '예: 2026년 4월 가격 인상',
      confirmButtonText: '업로드',
      cancelButtonText: '취소',
      confirmButtonColor: '#007aff',
      cancelButtonColor: '#a3a3a3',
      showCancelButton: true,
    });

    if (memo === undefined) return; // 취소

    const confirm = await swal.fire({
      title: '가격을 일괄 변경하시겠습니까?',
      text: '변경 전 가격은 이력에 저장되며, 롤백할 수 있습니다.',
      icon: 'warning',
      iconColor: '#f59e0b',
      confirmButtonText: '변경 실행',
      cancelButtonText: '취소',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#a3a3a3',
      showCancelButton: true,
    });

    if (!confirm.isConfirmed) return;

    try {
      setIsLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('memo', memo || '');
      const { data } = await axios.post('/admin/products/price-upload', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setIsLoading(false);
      swal.fire({
        title: '완료',
        html: `${data.updated}건 업데이트 (${data.changes_count}개 가격 변경)<br>${data.skipped}건 건너뜀`,
        icon: 'success',
        confirmButtonColor: '#007aff',
      });
      getProducts();
    } catch (err) {
      setIsLoading(false);
      const msg = err.response?.data?.message || '오류가 발생했습니다.';
      swal.fire({ text: msg, icon: 'error', confirmButtonColor: '#007aff' });
    }
  };

  const fetchHistory = async () => {
    try {
      const { data } = await axios.get('/admin/products/price-history');
      setHistory(data);
    } catch (e) { console.error(e); }
  };

  const handleRollback = async (h) => {
    const confirm = await swal.fire({
      title: '이 시점으로 롤백하시겠습니까?',
      html: `<b>${formatDate(h.uploaded_at)}</b> 시점의 가격으로 복원합니다.${h.memo ? `<br>메모: ${h.memo}` : ''}`,
      icon: 'warning',
      iconColor: '#dc2626',
      confirmButtonText: '롤백 실행',
      cancelButtonText: '취소',
      confirmButtonColor: '#dc2626',
      cancelButtonColor: '#a3a3a3',
      showCancelButton: true,
    });
    if (!confirm.isConfirmed) return;

    try {
      setIsLoading(true);
      const { data } = await axios.post(`/admin/products/price-rollback/${h._id}`);
      setIsLoading(false);
      swal.fire({ title: '롤백 완료', text: data.message, icon: 'success', confirmButtonColor: '#007aff' });
      getProducts();
      fetchHistory();
    } catch (err) {
      setIsLoading(false);
      swal.fire({ text: '오류가 발생했습니다.', icon: 'error', confirmButtonColor: '#007aff' });
    }
  };

  const toggleHistory = () => {
    if (!showHistory) fetchHistory();
    setShowHistory(!showHistory);
  };

  const formatDate = (str) => {
    if (!str) return '-';
    const m = str.match(/(\d{4})\.(\d{2})\.(\d{2})-?(\d{2}):(\d{2})/);
    if (m) return `${m[1].slice(2)}/${m[2]}/${m[3]} ${m[4]}:${m[5]}`;
    return str;
  };

  const titles = ['제조사', '카테고리', '제품명', 'VIP', 'Mall', 'Level1', 'Level2', 'Level3', 'School'];

  useEffect(() => { getProducts(); }, []);

  return (
    <Container>
      <div style={{ width: '100%', marginBottom: 4 }}>
        <h2 style={{ fontSize: 20, fontWeight: 700, color: '#111827', margin: 0 }}>전체 제품 가격표</h2>
      </div>
      <Toolbar>
        <span style={{ fontSize: 14, color: '#86868b' }}>총 {rawData.length}개</span>
        <BtnGroup>
          <Btn onClick={toggleHistory}>
            {showHistory ? '이력 닫기' : '변경 이력'}
          </Btn>
          <Btn $variant="primary" onClick={() => fileRef.current?.click()}>
            엑셀 업로드 (가격 변경)
          </Btn>
          <Btn $variant="excel" onClick={handleExcelDownload}>
            엑셀 다운로드
          </Btn>
          <input ref={fileRef} type="file" accept=".xlsx,.xls" onChange={handleExcelUpload} style={{ display: 'none' }} />
        </BtnGroup>
      </Toolbar>

      {showHistory && (
        <HistoryPanel>
          <h4 style={{ fontSize: 15, fontWeight: 700, color: '#1d1d1f', marginBottom: 12 }}>
            가격 변경 이력
          </h4>
          {history.length === 0 ? (
            <div style={{ color: '#86868b', fontSize: 14, padding: '20px 0', textAlign: 'center' }}>
              변경 이력이 없습니다.
            </div>
          ) : (
            history.map((h) => (
              <HistoryCard key={h._id}>
                <HistoryInfo>
                  <HistoryDate>{formatDate(h.uploaded_at)}</HistoryDate>
                  <HistoryMemo>
                    {h.memo || '(메모 없음)'}
                  </HistoryMemo>
                </HistoryInfo>
                <ChangeBadge>{h.changes?.length || 0}개 변경</ChangeBadge>
                <Btn $variant="danger" style={{ fontSize: 12, padding: '5px 12px' }}
                  onClick={() => handleRollback(h)}>
                  이 시점으로 롤백
                </Btn>
              </HistoryCard>
            ))
          )}
        </HistoryPanel>
      )}

      {products && products.length > 0 ? (
        <Table titles={titles} data={products} />
      ) : !isLoading && (
        <div style={{ color: '#86868b', fontSize: 15, padding: '80px 0', textAlign: 'center', width: '100%' }}>
          등록된 제품이 없습니다.
        </div>
      )}
      {isLoading && <Loading />}
    </Container>
  );
};

export default TotalProductListPage;
